import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-black mb-3" }, "Información básica", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-name"
}, "Nombre", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-lastname"
}, "Apellido", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-doc-type"
}, "Tipo documento", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-doc-number"
}, "Número documento", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-birthdate"
}, "Fecha de nacimiento", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-gender"
}, "Género", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-ethnicity"
}, "Etnia", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-indigenous"
}, "Resguardo indígena", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-siblings"
}, "Número de hermanos", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-household"
}, "¿Es jefe de hogar?", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-liveswith"
}, "Vive con", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-livesstreet"
}, "¿Vive en condición de calle?", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-icbf"
}, "Institución ICBF", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-bio"
}, "Biografía", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-notes"
}, "Notas", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-address"
}, "Dirección", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-desc-address"
}, " Indicaciones dirección Apto / Casa / Unidad / Otro ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-neighborhood"
}, "Barrio / Vereda", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-country"
}, "País", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-department"
}, "Departamento", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-city"
}, "Ciudad", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-household"
}, "¿Estudiante activo?", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_form_select = _resolveComponent("b-form-select")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_b_form_textarea = _resolveComponent("b-form-textarea")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_2,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-name",
                    class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && !_ctx.recordProxy.Name }]),
                    modelValue: _ctx.recordProxy.Name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = val => _ctx.updateField('Name', val)),
                    placeholder: "Ingrese nombre",
                    type: "text",
                    required: ""
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode(_component_b_form_invalid_feedback, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Campo requerido")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_3,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-lastname",
                    class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && !_ctx.recordProxy.LastName }]),
                    modelValue: _ctx.recordProxy.LastName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = val => _ctx.updateField('LastName', val)),
                    type: "text",
                    required: "",
                    placeholder: "Ingrese apellido"
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode(_component_b_form_invalid_feedback, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Campo requerido")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_4,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_select, {
                    id: "input-doc-type",
                    class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && !_ctx.recordProxy.DocumentType }]),
                    modelValue: _ctx.recordProxy.DocumentType,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = val => _ctx.updateField('DocumentType', val)),
                    options: _ctx.Documents,
                    "value-field": "Id",
                    "text-field": "Description",
                    required: ""
                  }, null, 8, ["modelValue", "options", "class"]),
                  _createVNode(_component_b_form_invalid_feedback, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Campo requerido")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_5,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-doc-number",
                    class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && !_ctx.recordProxy.IdentificationNumber }]),
                    modelValue: _ctx.recordProxy.IdentificationNumber,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = val => _ctx.updateField('IdentificationNumber', val)),
                    placeholder: "Ingrese número documento",
                    type: "text",
                    required: ""
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode(_component_b_form_invalid_feedback, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Campo requerido")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, {
          cols: "12",
          md: "3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_6,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-birthdate",
                    class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && !_ctx.recordProxy.BirthDate }]),
                    modelValue: _ctx.recordProxy.BirthDate,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = val => _ctx.updateField('BirthDate', val)),
                    type: "date",
                    required: ""
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode(_component_b_form_invalid_feedback, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Campo requerido")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, {
          cols: "12",
          md: "3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, {
              label: "Lugar de nacimiento",
              "label-for": "input-birthplace"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_input, {
                  id: "input-birthplace",
                  modelValue: _ctx.recordProxy.BirthPlace,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = val => _ctx.updateField('BirthPlace', val)),
                  placeholder: "Ciudad / Departamento / Otro"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_7,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_select, {
                    id: "input-gender",
                    class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && !_ctx.recordProxy.Gender }]),
                    modelValue: _ctx.recordProxy.Gender,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = val => _ctx.updateField('Gender', val)),
                    options: ['Femenino', 'Masculino', 'No_binario', 'Genero_fluido', 'Prefiero_no_decirlo'],
                    required: ""
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode(_component_b_form_invalid_feedback, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Campo requerido")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_8,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-ethnicity",
                    class: "form-control fs-14 text-black shadow-none form-control-sm",
                    modelValue: _ctx.recordProxy.Ethnicity,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = val => _ctx.updateField('Ethnicity', val)),
                    placeholder: "Ingrese etnia",
                    type: "text"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_9,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-indigenous",
                    class: "form-control fs-14 text-black shadow-none form-control-sm",
                    modelValue: _ctx.recordProxy.IndigenousResguardo,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = val => _ctx.updateField('IndigenousResguardo', val)),
                    placeholder: "Ingrese resguardo indígena",
                    type: "text"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_10,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-siblings",
                    class: "form-control fs-14 text-black shadow-none form-control-sm",
                    modelValue: _ctx.recordProxy.NumberOfSiblings,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = val => _ctx.updateField('NumberOfSiblings', _ctx.toNumber(val))),
                    type: "number"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_11,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_checkbox, {
                    id: "input-household",
                    modelValue: _ctx.recordProxy.IsHouseholdHead,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = val => _ctx.updateField('IsHouseholdHead', !!val))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_12,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-liveswith",
                    class: "form-control fs-14 text-black shadow-none form-control-sm",
                    modelValue: _ctx.recordProxy.LivesWith,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = val => _ctx.updateField('LivesWith', val)),
                    type: "text"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_13,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_checkbox, {
                    id: "input-livesstreet",
                    modelValue: _ctx.recordProxy.LivesOnStreet,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = val => _ctx.updateField('LivesOnStreet', !!val))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_14,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-icbf",
                    class: "form-control fs-14 text-black shadow-none form-control-sm",
                    modelValue: _ctx.recordProxy.ICBFInstitutionName,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = val => _ctx.updateField('ICBFInstitutionName', val)),
                    type: "text"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_15,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_textarea, {
                    id: "input-bio",
                    class: "form-control fs-14 text-black shadow-none form-control-sm",
                    modelValue: _ctx.recordProxy.Biography,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = val => _ctx.updateField('Biography', val))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_16,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_textarea, {
                    id: "input-notes",
                    class: "form-control fs-14 text-black shadow-none form-control-sm",
                    modelValue: _ctx.recordProxy.Notes,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = val => _ctx.updateField('Notes', val))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_17,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-address",
                    class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && !_ctx.recordProxy.Address }]),
                    modelValue: _ctx.recordProxy.Address,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = val => _ctx.updateField('Address', val)),
                    type: "text",
                    required: ""
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode(_component_b_form_invalid_feedback, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Campo requerido")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_18,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-desc-address",
                    class: "form-control fs-14 text-black shadow-none form-control-sm",
                    modelValue: _ctx.recordProxy.DescriptionAddress,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = val => _ctx.updateField('DescriptionAddress', val)),
                    type: "text"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_19,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-neighborhood",
                    class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && !_ctx.recordProxy.Neighborhood }]),
                    modelValue: _ctx.recordProxy.Neighborhood,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = val => _ctx.updateField('Neighborhood', val)),
                    type: "text",
                    required: ""
                  }, null, 8, ["modelValue", "class"])
                ]),
                _createVNode(_component_b_form_invalid_feedback, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Campo requerido")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_20,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_select, {
                    id: "input-country",
                    class: "form-control fs-14 text-black shadow-none form-control-sm",
                    modelValue: _ctx.recordProxy.Country,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = val => _ctx.updateField('Country', val)),
                    options: _ctx.Country,
                    "value-field": "Id",
                    "text-field": "Name"
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_21,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_select, {
                    id: "input-department",
                    class: "form-control fs-14 text-black shadow-none form-control-sm",
                    modelValue: _ctx.recordProxy.Department,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = val => _ctx.updateField('Department', val)),
                    options: _ctx.Department,
                    "value-field": "Id",
                    "text-field": "Name"
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_22,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_select, {
                    id: "input-city",
                    class: "form-control fs-14 text-black shadow-none form-control-sm",
                    modelValue: _ctx.recordProxy.City,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = val => _ctx.updateField('City', val)),
                    options: _ctx.City,
                    "value-field": "Id",
                    "text-field": "Name"
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.recordProxy.Id > 0)
      ? (_openBlock(), _createBlock(_component_b_row, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_b_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_group, null, {
                  default: _withCtx(() => [
                    _hoisted_23,
                    _createElementVNode("div", null, [
                      _createVNode(_component_b_form_checkbox, {
                        id: "input-enable",
                        modelValue: _ctx.recordProxy.Enable,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = val => _ctx.updateField('Enable', !!val))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}